import React, { createContext, useState } from "react";

export const SelectedCityContext = createContext(); 

export const SelectedCityProvider = ({ children }) => {
    const [selectedCity, setSelectedCity] = useState('None');

  return (
    <SelectedCityContext.Provider value={{ selectedCity, setSelectedCity }}>
      {children} 
    </SelectedCityContext.Provider>
  );
};
